import React from 'react';
import _get from 'lodash.get';
import Layout from 'components_v2/desktop/Layout';
import { isApp } from 'utils/getParams';
import { getSiteConfig } from 'reduxUtils/modules/common';
import { SomethingWentWrong } from 'components_v2/common/SomethingWentWrong/SomethingWentWrong';
import { loadLayoutDataPrintAS } from 'reduxUtils/modules_v2/layout';
import { loadArticleshowData } from 'routes/printarticleshow/redux';
import { getCustomDimension8, getSectionsListFromBreadCrumb } from 'utils/common';
import PrintArticleShow from 'routes/printarticleshow/components/common/PrintArticleShow';
import { IParams } from 'routes/printarticleshow/printASutils';

const pageName = 'printarticle_desktop';
const gapageName = 'print_as';

interface IStore {
  getState: () => any;
  dispatch: (args: any) => void;
}
interface IContext {
  path: string;
  query: { [key: string]: any };
  store: IStore;
  pathname: string;
  params?: IParams;
}
interface ISection {
  subsec6?: {
    subsecname6: string;
  };
}

interface IGAData {
  dimension8?: string
  dimension9?: string
  dimension5?: string
  dimension4?: string
  dimension35?: string
}
declare global {
  interface Window {
    abPrintLock: string
  }
}

async function action(context: IContext, params: IParams) {
  const dataPromiseArray = [];
  const localParams = { location: context.path };
  let state = context.store.getState();
  const isAppView: boolean = isApp(context.query);
  const queryParams: { [key: string]: any; } = context.query;
  const isWapView: boolean = false;
  const isUserPrime: boolean = !!state.isPrime;
  const urlPath: string = context.pathname;
  const isEPaper: boolean = context?.query?.tophead === 'epaper';
  const isEpaperApp: boolean = context.query?.apptype === 'epaper';
  const isDigitalApp: boolean = context.query?.apptype === 'digitalview';
  const newParams: IParams = {
    ...localParams,
    fullPath: `/printarticle/${params.msid}.cms`,
    isWapView,
    skipSubSections: false,
    isAppView,
    isPrime: isUserPrime,
    msid: params.msid,
    frmprime: state.isPrime ? 'yes' : '',
    urlPath,
    queryParams,
    isEPaper:isEPaper,
  };

  if (!state.header.data || !state.footer_v2.data) {
    dataPromiseArray.push(context.store.dispatch(loadLayoutDataPrintAS(newParams)));
  }

  if (!state.printeditionas.data) {
    dataPromiseArray.push(context.store.dispatch(loadArticleshowData(newParams)));
  }

  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
  }

  const getGAConfig = async () => {
    let gaData: IGAData = {};
    if (
      state.printeditionas &&
      state.printeditionas.data &&
      state.printeditionas.data[params.msid]
    ) {
      const article = state.printeditionas.data[params.msid]
      if (article.ag) {
        gaData.dimension5 = article.ag;
      }
      if (article.authors && article.authors.length > 0) {
        let author = '';
        for (let i = 0; i < article.authors.length; i += 1) {
          author += article.authors[i].name;
          if (article.authors.length > 1 && i !== article.authors.length - 1) {
            author += ' and ';
          }
        }

        gaData.dimension4 = author;
      }
      if (article.hl) {
        gaData.dimension35 = article.hl;
      }
    }
    const sectionsNameList = getSectionsListFromBreadCrumb(
      state.navigation && state.navigation.breadCrumbs
        ? state.navigation.breadCrumbs
        : [],
    );
    gaData.dimension8 = getCustomDimension8(sectionsNameList);
    gaData.dimension9 = gapageName;
    const sectionValues: ISection[] = Object.values(
      state.printeditionas.data[params.msid].navsubsecs,
    );

    const section: ISection | null =
      Array.isArray(sectionValues) && sectionValues.length > 0
        ? sectionValues[sectionValues.length - 1]
        : null;

    gaData.dimension8 = section?.subsec6?.subsecname6;
    return gaData;
  };

  state = context.store.getState();
  let status = 200;
  const title = 'Get Latest News Updates from Times Of India';
  let dataAvailable =
    state.printeditionas &&
    state.printeditionas.data &&
    state.printeditionas.data[params.msid];
  if (typeof window === 'undefined' && !dataAvailable) {
    status = 404;
  }
  const storyTitle = state?.printeditionas?.data
    ? state.printeditionas.data[params?.msid]?.hl
    : '';
  let img;
  let imageInfo = [];
  const defaultImage = state.printeditionas.data[params.msid]?.images[0];
  const webImage = state.printeditionas.data[params.msid]?.images?.find(
    (el: { [key: string]: any }) => el?.payload?.toLowerCase() === 'OverrideLeadImage'.toLowerCase(),
  );
  if (
    state.printeditionas?.data[params.msid]?.metaInfo?.Hideheadline === '1'
  ) {
    img = webImage || defaultImage;
  }
  img = webImage || defaultImage;
  if (img) {
    imageInfo.push(
      `https://static.toiimg.com/thumb/width-800,height-450,${img?.imagesize ? `imgsize-${img.imagesize}` : ''
      },msid-${img?.id}/${img?.id}.jpg`,
    );
  }
  const showPreload = imageInfo instanceof Array && imageInfo.length > 0;

  const getComponent = () => {
    if (!dataAvailable) {
      return <SomethingWentWrong printLayout isWapView={false} />
    }

    const layoutProps = {
      params: newParams,
      query: Object.keys(context.query).length ? context.query : {},
      isPrime: state.isPrime,
      skipAds: true,
      pageType: "printeditionas",
      // layoutClass: "printLayout printeditionas",
      printLayout: true,
      hideBreadcrumAtBottom: true,
      hideGetAppWidget: true,
      hideGetAppBtn: true,
      hideAdCude: true,
      headerClass: "fix-header-zero",
      layoutType: 'printeditioncontentwrapper',
      hideBackToTop: true,
      hideAdBlockerDetector: true,
      hideAffiliatesFloatingNudge: true,
      isEpaperApp:isEpaperApp,
      isDigitalApp: isDigitalApp,
    }

    return (
      <Layout {...layoutProps}>
        <PrintArticleShow isWapView={false} parentMsid={params.msid} urlPath={urlPath} isUserPrime={isUserPrime} storyTitle={storyTitle} isAppView={isAppView} params={newParams} isEPaper={isEPaper} isEpaperApp={isEpaperApp} />
      </Layout>);
  }
  const gtmIDForOptimisely = ['GTM-KCRX3PN'];
  const printAsSeo = state.printeditionas?.data[params.msid]?.seo || {};
  return {
    chunks: [pageName],
    title,
    seoData: {
      ...printAsSeo,
      schema: state.printeditionas?.data[params.msid]?.schema || [],
      robots: 'noindex,nofollow',
    },
    status,
    component: getComponent(),
    maxAge: 900, // 15 minutes
    gaData: await getGAConfig(),
    preconnectDomains: [],
    gtmIDList: gtmIDForOptimisely,
    headTags: [],
    skipColumbiaScript: true,
    skipImaScript: true,
    skipPubmaticScript: true,
    skipPageViewGAOnLoad: true,
    isPrime: state.isPrime,
    skipRouteAds: true,
    useVariableFonts: true,
    inlineFirstFoldCSS: true,
    isPerfExperimented: true,
    // TOIPlusRoute: true,
    showPreload,
    imageInfo,
  };
}

export default action;
